/* Auth */
export const LOGIN_REQUESTED = "LOGIN_REQUESTED";
export const LOGIN_SUCCEEDED = "LOGIN_SUCCEEDED";

/* Papers */
export const LOAD_PAPERS = "LOAD_PAPERS";
export const REMOVE_PAPER_FROM_UNASSIGNED = "REMOVE_PAPER_FROM_UNASSIGNED";
export const ADD_PAPER_TO_UNASSIGNED = "ADD_PAPER_TO_UNASSIGNED";
export const SET_ARE_PAPERS_LOADED = "SET_ARE_PAPERS_LOADED";

/* Sessions */
export const ADD_SESSION = "ADD_SESSION";
export const LOAD_SESSIONS = "LOAD_SESSIONS";
export const ADD_TO_UNASSIGNED = "ADD_TO_UNASSIGNED";
export const REMOVE_FROM_UNASSIGNED = "REMOVE_FROM_UNASSIGNED";
export const UPDATE_SESSION = "UPDATE_SESSION";
export const DELETE_SESSION = "DELETE_SESSION";
export const CHANGE_SESSION_COLOR = "CHANGE_SESSION_COLOR";

/* Rooms */
export const ADD_ROOM = "ADD_ROOM";
export const UPDATE_ROOM = "UPDATE_ROOM";
export const DELETE_ROOM = "DELETE_ROOM";

/* Calendar */
export const LOAD_CALENDAR = "LOAD_CALENDAR";
export const CHANGE_SELECTED_DAY = "CHANGE_SELECTED_DAY";
export const ADD_CALENDAR_SESSION = "ADD_CALENDAR_SESSION";
export const UPDATE_CALENDAR_SESSION = "UPDATE_CALENDAR_SESSION";
export const DELETE_CALENDAR_SESSION = "DELETE_CALENDAR_SESSION";
export const DELETE_CALENDAR_SESSION_BY_SESSION_ID = "DELETE_CALENDAR_SESSION_BY_SESSION_ID";
